<div class="modal-body width-800">
  <h5 class="modal-header">
    {{getRessource('Create')}}
  </h5>
  <div class="span-3 typo-normal">
    <exg-input [required]="uiModel.apiBezeichnung.length === 0" [hintText]="'Bezeichnung darf nicht leer sein'"
	             [(ngModel)]="uiModel.apiBezeichnung"
               [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiBezeichnung')"
               name="apiBezeichnung" type="text">
    </exg-input>
    <div>
      <exg-select [(ngModel)]="uiModel.apiSequence"
                  [list]="data.worklistData" type="text"
                  name="apiSequence"
                  listdisplay="apiBezeichnung"
                  *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT') && !(data.worklistData && data.worklistData.length === 0)"
                  [caption]="getRessource('caption.apiSequence')">
      </exg-select>
      <div class="grid cols-3"
           *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')">
        <exg-checkbox class="md-check-reverse typo-small"
                      *ngIf="excSecurityService.isFeatured('SCHEDULEAPPROVE')"
                      [(ngModel)]="uiModel.apiFreigabe"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                      type="switch"></exg-checkbox>
        <exg-checkbox class="md-check-reverse typo-small" [(ngModel)]="uiModel.apiPruefen"
                      *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiPruefen')"
                      type="switch"></exg-checkbox>
        <exg-checkbox class="md-check-reverse typo-small" [(ngModel)]="uiModel.apiMonitoring"
                      *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                      type="switch"></exg-checkbox>
      </div>
      <form #modalReceipt="ngForm" class="modal-form">
        <div class="grid cols-3">
          <ng-container *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')">
            <exg-input [(ngModel)]="uiModel.apiSollDatum" [step]="60"
                       [required]="!uiModel.apiSollDatum" [hintText]="'Pflichtangabe'"
                       [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiSollDatum')"
                       name="apiSollDatum" type="datetime-local" [isEpoch]=true>
            </exg-input>
          </ng-container>
	        <div class="spawn">
		        <exg-input [ngModel]="uiModelDates.apiPlanDatumDate"
		                   (ngModelChange)="combineDateTime('apiPlanDatum', $event, uiModelDates.apiPlanDatumTime)"
		                   [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiPlanDatum')"
		                   name="apiPlanDatumDate"
		                   type="date">
		        </exg-input>
		        <exg-input [ngModel]="uiModelDates.apiPlanDatumTime" [step]="60"
		                   (ngModelChange)="combineDateTime('apiPlanDatum', uiModelDates.apiPlanDatumDate, $event)"
		                   [caption]="''"
		                   name="apiPlanDatumTime"
		                   type="time">
		        </exg-input>
	        </div>
	        <div class="spawn">
		        <exg-input [ngModel]="uiModelDates.apiIstDatumDate"
		                   (ngModelChange)="combineDateTime('apiIstDatum', $event, uiModelDates.apiIstDatumTime)"
		                   [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiIstDatum')"
		                   name="apiIstDatumDatum"
		                   type="date">
		        </exg-input>
		        <exg-input [ngModel]="uiModelDates.apiIstDatumTime" [step]="60"
		                   (ngModelChange)="combineDateTime('apiIstDatum', uiModelDates.apiIstDatumDate, $event)"
		                   [caption]="''"
		                   name="apiIstDatumTime"
		                   type="time">
		        </exg-input>
	        </div>
        </div>
        <exg-textarea [(ngModel)]="uiModel.apiKommentar"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiKommentar')"
                      [class.disabled]="excSecurityService.isFeatured('SCHEDULEMGMT')"
                      type="text" #nodeText name="apiKommentar">
        </exg-textarea>
      </form>
      <div class="spawn-modal-actions">
        <button class="md-btn"
                [class.disabled]="!uiModel.apiSollDatum || uiModel.apiBezeichnung.length === 0"
                (click)="clickedSave()">Speichern</button>
        <button class="md-btn" (click)="clickedCancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</div>
